<template>
  <div class="main--text">
    <!-- <h3>第１章　利用総則</h3> -->
    <!-- <h4>第１条　利用規約</h4> -->
    <h2 class="title--text">利用規約</h2>
    <p class="plain--text">この利用規約（以下、「本規約」といいます。）は、株式会社Nuco（以下、「当社」といいます。）がこのウェブサイト（以下、「本サイト」といいます。）上で提供するサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。<br>
    家庭教師として本サービスに登録する皆さま（以下、「先生」といいます。）には、本規約に従って、本サービスをご利用いただきます。</p>
    <!-- <span>
      この利用規約（以下、「本規約」といいます。）は、株式会社Nuco（以下、「当社」といいます。）が提供する家庭教師クラウドソーシングプラットフォームサービス「Prosense」（以下、「本サービス」といいます。）の利用条件を定めるものです。
      家庭教師として本サービスを利用する登録ユーザーである先生（以下、「先生」といいます。）には、本規約に従って、本サービスをご利用いただきます。
      先生が未成年者である場合、本サービスの利用に関して事前に法定代理人の同意を得るものとし、上記同意を得ていることを当社及び依頼者に対して保証します。
      本規約は、先生と当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
    </span> -->
    <h3 class="subtitle--text">第1条（適用）</h3>
    <ol type="1" class="plain--list">
      <li>本規約は、先生と当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</li>
      <li>当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます。）をすることがあります。
        これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。</li>
      <li>本規約の規定が前条の個別規定の規定と矛盾する場合には、個別規定において特段の定めなき限り、個別規定の規定が優先されるものとします。</li>
    </ol>
    <h3 class="subtitle--text">第2条（定義）</h3>
    <p class="plain--text">本規約における用語の定義は、特別の定めがある場合を除き、次の各号のとおりとします。</p>
    <ol type="1" class="plain--list">
      <li>生徒：先生から家庭教師サービスを受ける学生</li>
      <li>依頼者：本サービスにおいて家庭教師の紹介を受けることを希望する保護者等の利用者</li>
      <li>家庭教師実施契約：依頼者と先生との間で本サービスを通じて締結される家庭教師サービスの実施契約</li>
      <li>未払報酬残高：本サービスにおいて当社が先生に支払う金額として設定される残高</li>
    </ol>
    <h3 class="subtitle--text">第3条（利用者の資格）</h3>
    <ol type="1" class="plain--list">
      <li>先生が未成年者である場合、本サービスの利用に関して事前に法定代理人の同意を得るものとし、上記同意を得ていることを当社及び依頼者に対して保証します。</li>
    </ol>
    <h3 class="subtitle--text">第4条（利用登録）</h3>
    <ol type="1" class="plain--list">
      <li>本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請することによって、利用登録が完了するものとします。</li>
      <li>当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。</li>
      <ol type="a">
        <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
        <li>本規約に違反したことがある者からの申請である場合</li>
        <li>その他、当社が利用登録を相当でないと判断した場合</li>
      </ol>
    </ol>
    <h3 class="subtitle--text">第5条（アカウントの管理）</h3>
    <ol type="1" class="plain--list">
      <li>先生は、自己の責任において、本サービスのユーザーID（メールアドレス）およびパスワードを適切に管理するものとします。</li>
      <li>先生は、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。
        当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録している先生自身による利用とみなします。</li>
      <li>ユーザーID及びパスワードが第三者によって使用されたことによって生じた損害は、当社に故意又は重大な過失がある場合を除き、当社は一切の責任を負わないものとします。</li>
    </ol>
    <h3 class="subtitle--text">第6条（登録情報）</h3>
    <ol type="1" class="plain--list">
      <li>先生は、当社に、当社が定める方法により、先生に関する情報、生徒に関する情報その他当社所定の情報を登録するものとします。</li>
      <li>先生は、当社に登録した内容に変更があった場合、当社が定める方法により、登録情報の変更手続を行わなければなりません。
        変更しないことにより先生に生じた不利益については、先生が一切の責任を負うこととし、当社は責任を負いません。</li>
      <li>先生は、本条に基づき登録する情報の正確性について保証します。</li>
      <li>先生が虚偽の情報を登録したことにより先生を含む第三者に対して損害を与えた場合、先生は当該損害について責任を負うものとします。</li>
      <li>先生は、本条によって登録した情報（氏名のイニシャル、最寄り駅、最寄り駅からの経路など）が本サイト上で開示されることに同意します。</li>
      <li>先生は、次条に基づき依頼者との間で家庭教師実施契約が成立した場合、依頼者が先生に対して先生の氏名、住所、メールアドレス、生徒の在学校、その他必要な事項を開示することに同意します。
        また、当社は、先生が本サイトにおいて先生との間で家庭教師実施契約を成立させる手続を操作した場合には、同操作をもって、先生が先生に関する上記の必要情報を当該先生に対して開示することに個別同意したと見なすことができるものとし、先生は予めこれに同意します。</li>
    </ol>
    <h3 class="subtitle--text">第7条（家庭教師実施契約）</h3>
    <ol type="1" class="plain--list">
      <li>先生と先生が、本サイト上で手続を行い、家庭教師サービスを受ける生徒、授業料、交通費、授業日程その他当社が定める事項について合意した場合には、当該合意に係る事項及び次の各号に基づいて、先生と先生との間で家庭教師実施契約が成立するものとします。</li>
      <ol type="a">
        <li>先生は、依頼者との間の合意内容に従って、生徒に授業を行います。</li>
        <li>授業日程の変更、授業のキャンセルその他家庭教師実施契約の内容の変更については、本サイト上で依頼者と先生の双方が手続を終えた時点又は当社がこれに代わる措置を執った時点で有効となります。</li>
        <li>依頼者と先生は、依頼者と先生が合意した全ての授業に係る授業料及び交通費が先生の収納代行者である当社に支払われたことを確認します。</li>
        <li>一つの授業が問題なく終了した場合、先生は、翌日までに、本サイト上での手続を通して授業報告を行うものとし、当該授業報告に異議がない場合、依頼者は、授業報告がなされた日の翌日までに、本サイト上での手続により、当該授業報告を是認するものとします。</li>
        <li>先生の授業報告に問題がある場合、依頼者は、授業報告がなされた日の翌日までに本サイト上の問合せフォームから当社にその旨を報告するものとします。</li>
        <li>依頼者が授業報告を是認した場合又は授業報告がなされた日から14日以内に依頼者が当社に対して前号の報告をしなかった場合、授業報告どおりの授業がなされたものとみなします。</li>
        <li>授業予定日に授業が行われなかった場合、依頼者及び先生は、当該授業予定日の翌日までに、本サイト上の問合せフォームから当社に報告するものとします。また、本サイト外において依頼者と先生との間で授業予定日を変更（延期）したために授業予定日に授業が行われなかった場合、依頼者及び先生は、元々の授業予定日の翌日までに、本サイト上で授業予定日の変更手続を行うものとします。</li>
        <li>依頼者から第(e)号の報告があった場合、依頼者又は先生から第(g)号の報告があった場合、授業予定日の翌日までに先生から授業報告がなされなかった場合、その他当該授業についての先生から依頼者への返金の要否について判断をする必要が生じた場合には、当社が当該返金の要否や依頼者、生徒又は先生の責めに帰する事由の有無等について判断することとします。依頼者及び先生は、当社の判断に異議を述べることなく従うものとします。</li>
        <li>本サイト上の手続による授業キャンセル又は依頼者もしくは生徒の責めに帰さない事由による授業の不実施等の状況が発生し、当社が依頼者に対して返金すべきと判断した場合には、先生は、当社を通じて、依頼者に対して当該授業に係る授業料と交通費を返金します。但し、依頼者又は生徒の責めに帰すべき事由により授業が実施されなかった場合には、いかる理由であれ、先生は依頼者に対して授業料及び交通費を返金する義務を負わないものとします。</li>
        <li>一つの授業についての依頼者と先生との間の損害賠償義務は、前号の規定により返金されること又は返金されないことをもって解決されるものとします。</li>
      </ol>
      <li>依頼者は、家庭教師実施契約は依頼者と先生との間の契約であり、当社は家庭教師実施契約の当事者とならず、当社が家庭教師実施契約に基づく責任を負うものではないことを確認します。</li>
    </ol>
    <h3 class="subtitle--text">第8条（利用料金および支払い方法）</h3>
    <ol type="1" class="plain--list">
      <li>依頼者の、当社に対する本サービス利用料は、無料とします。</li>
      <li>依頼者の先生に対する家庭教師実施報酬のお支払いは、次の各号に基づきます。</li>
    </ol>
    <h3 class="subtitle--text">第9条（本サービス利用に関する禁止事項）</h3>
    <p class="plain--text">依頼者は、本サービスの利用にあたり、次の各号に掲げる行為をしてはなりません。</p>
    <ol type="1" class="plain--list">
      <li>当社に虚偽の情報を登録する行為</li>
      <li>当社又は第三者の知的財産権その他財産権、プライバシー権又は肖像権を侵害する行為</li>
      <li>当社又は第三者の名誉又は信用を毀損する行為</li>
      <li>当社又は第三者を誹謗中傷する行為</li>
      <li>当社又は第三者に経済的損害を与える行為</li>
      <li>当社又は第三者に対する脅迫的な行為</li>
      <li>他の依頼者、他の生徒や先生の個人情報等を収集又は蓄積する行為</li>
      <li>他人に成りすます行為</li>
      <li>個人情報を他の依頼者、他の生徒、先生や第三者に漏洩する行為</li>
      <li>当社による本サービスの運営を妨害するおそれのある行為</li>
      <li>当社が提供するインターフェース以外の方法で本サービスにアクセスを試みる行為</li>
      <li>犯罪に結びつく行為</li>
      <li>前各号に掲げるほか、当社が不適切と判断する行為</li>
    </ol>
    <h3 class="subtitle--text">第10条（先生との直接取引に関する事項）</h3>
    <ol type="1" class="plain--list">
      <li>先生は、本サービスを通じて知り合った依頼者もしくは生徒から、本サービスを利用せずに家庭教師サービスを受け、又は生徒その他第三者に家庭教師サービスを受けさせてはなりません。ただし、当社が本サービスの提供を永続的に終了した後についてはこの限りではありません。</li>
      <li>先生が前項の規定に違反した場合、先生は、本サービスを利用していたならば先生が当社に支払ったであろう本サービスの利用料の3倍に相当する金額（その額が100万円に満たない場合は100万円）の違約金を、先生と連帯して、直ちに当社に支払わなければなりません。</li>
      <li>先生は、当社が前項の違約金の請求にあたって弁護士費用その他費用を要した場合には、その費用についても先生と連帯して、直ちに当社に支払わなければなりません。</li>
    </ol>
    <h3 class="subtitle--text">第11条（本サービスの提供の停止等）</h3>
    <ol type="1" class="plain--list">
      <li>当社は、必要に応じて、先生に事前に通知することなく、本サービスの全部又は一部の提供を一時停止又は中断することができるものとします。</li>
      <li>当社は、本サービスの提供の一時停止又は中断により、先生、生徒又は第三者が被ったいかなる不利益又は損害についても、理由を問わず一切の責任を負わないものとします。</li>
    </ol>
    <h3 class="subtitle--text">第12条（利用制限及び登録抹消）</h3>
    <ol type="1" class="plain--list">
      <li>当社は、以下の各号のいずれかに該当する場合には、事前の通知なく、先生による本サービスの利用を制限し、又は先生のアカウントを削除して以後先生に本サービスを利用させないことができるものとします。</li>
      <ol type="a">
        <li>先生が本規約のいずれかの条項に違反した場合</li>
        <li>先生が本サービスのアカウント登録手続において虚偽の事実を申請した場合</li>
        <li>本規約のいずれかの条項に以前違反したことのある先生が新たに本利用契約を締結した場合</li>
        <li>先生が、暴力団、暴力団関係企業、総会屋もしくはこれらに準ずる者又はその構成員（以下「反社会的勢力」と総称します。）である場合</li>
        <li>先生に近しい関係者が反社会的勢力である場合</li>
        <li>先生が反社会的勢力に自己の名義を利用させて本利用契約を締結した場合</li>
        <li>前各号に掲げるほか、当社が先生による本サービスの利用を適当でないと判断した場合</li>
      </ol>
      <li>当社は、前項の規定に基づき当社が行った利用の制限、アカウントの削除又は本サービスの利用中止により先生に生じた損害について、一切の責任を負いません。</li>
    </ol>
    <h3 class="subtitle--text">第13条（退会）</h3>
    <p class="plain--text">先生は、当社の定める退会手続により、本サービスから退会できるものとします。</p>
    <h3 class="subtitle--text">第14条（保証の否認および免責事項）</h3>
    <ol type="1" class="plain--list">
      <li>当社は、本サービスから先生が得る情報（先生の登録情報を含みます。）の正確性等についていかなる保証も行なわず、一切の責任を負いません。
        先生は、本サービスから得る情報の正確性等につき、自己の責任において判断するものとします。</li>
      <li>当社は、先生による家庭教師サービスの品質や、本サービスの利用による生徒の成績向上等について、いかなる保証も行なわず、一切の責任を負いません。</li>
      <li>当社は、本サービスに関して、先生と他の先生、他の依頼者又は第三者との間において生じた取引（家庭教師実施契約を含みます。）、連絡又は紛争等について一切責任を負いません。</li>
      <li>当社の債務不履行責任は、当社の故意又は重過失によらない場合には、免責されるものとします。</li>
      <li>当社は、本サイトに不具合が生じないことについて、何ら保証するものではありません。</li>
      <li>当社は、本サイトが先生の利用環境に適合していることを保証するものではなく、本サイトの先生の利用環境への適合性については一切の責任を負いません。</li>
      <li>当社は、何らかの理由によって責任を負う場合でも、その賠償責任の範囲は、通常生じうる損害の範囲内かつ先生1名につき3万円を上限とします。</li>
      <li>当社が先生に対して支払いすることを目的として当社から先生に対して問合せをしたにも関わらず、先生が6か月以上に渡り適切な返答又は情報提供をしなかったことにより当社から先生に対する支払が処理できなかった場合、当社は当該金員について支払義務を免れるものとします。</li>
    </ol>
    <h3 class="subtitle--text">第15条（秘密の保持）</h3>
    <p class="plain--text">先生は、本サービスの利用に関して当社又は先生から開示又は提供された情報を善良なる管理者の注意をもって取扱い、事前に書面により当社の同意を得ることなく、本サービスの目的以外に使用し、又は第三者に開示又は提供してはならないものとします。</p>
    <h3 class="subtitle--text">第16条（サービス内容の変更等）</h3>
    <ol type="1" class="plain--list">
      <li>当社は、先生に通知することなく、本サービスの内容を変更し又は本サービスの提供を永続的に終了することができるものとします。</li>
      <li>先生は、当社が本サービスの提供を永続的に終了した場合、それ以降は本サービスを利用することはできません。</li>
      <li>当社は、本サービスの内容の変更又は本サービスの提供の永続的な終了によって先生に生じた損害について、一切の責任を負いません。</li>
    </ol>
    <h3 class="subtitle--text">第17条（利用規約の変更）</h3>
    <ol type="1" class="plain--list">
      <li>当社は、当社の判断において本規約を変更することができるものとします。本規約が変更された場合、先生と当社との間の本利用契約も、本規約の変更内容に応じて変更されるものとします。</li>
      <li>当社が本規約を変更する場合、本サイトを通じて、本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を先生に周知するものとします。</li>
    </ol>
    <h3 class="subtitle--text">第18条（個人情報の取り扱い）</h3>
    <p class="plain--text">当社は，本サービスの利用によって取得する個人情報については，当社「プライバシーポリシー」に従い適切に取り扱うものとします。</p>
    <h3 class="subtitle--text">第19条（損害賠償）</h3>
    <ol type="1" class="plain--list">
      <li>先生が本サービスの利用に関連して当社に損害を与えた場合、先生の費用と責任において、当社に対して損害（訴訟費用及び弁護士費用を含みます。）を賠償するものとします。</li>
      <li> 先生の行為により、第三者から当社が損害賠償等の請求をされた場合には、先生の費用と責任で、これを解決するものとします。
        当社が、当該第三者に対して、損害賠償金その他の費用を支出した場合には、先生は、当社に対して、当社に生じた一切の費用（損害賠償金及び弁護士費用を含みます。）を支払うものとします。</li>
    </ol>
    <h3 class="subtitle--text">第20条（通知または連絡）</h3>
    <p class="plain--text">先生と当社との間の通知及び連絡は、本サイトにログインした際に本サイト上で表示されるメッセージ又はその他当社が別途定める方法によって行うものとします。</p>
    <h3 class="subtitle--text">第21条（権利義務の譲渡の禁止）</h3>
      <p class="plain--text">先生は、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。</p>
    <h3 class="subtitle--text">第22条（分割可能性）</h3>
      <p class="plain--text">本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りのその他の条項、及び一部が無効又は執行不能と判断された条項の残りの部分は、継続して完全にその効力を有するものとします。</p>
    <h3 class="subtitle--text">第23条（準拠法・裁判管轄）</h3>
    <ol type="1" class="plain--list">
      <li >本規約及び本利用契約並びにこれらに係る法律行為については、日本法を準拠法とします。</li>
      <li>先生と当社とを当事者とする本サービスに関する訴えその他紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
    </ol>
    <p class="plain--text end">以上<br>2019年10月1日制定</p>





    <h4>第３条　本規約の変更</h4>
    <span>
      1. 当社は、必要と判断した場合には、先生に通知することなくいつでも本規約の変更ができるものとします。<br>
      2. 当社が本規約を変更する場合、本サービスのためのウェブサイト(以下、「本サイト」といいます。)を通じて、本規約の変更について先生に公表します。
      なお、本規約の変更後、先生が本サービスの利用を開始した場合には、変更後の規約に同意したものとみなします。      
    </span>
    <h4>第４条　通知または連絡</h4>
    <span>
      1. 先生と当社との間の通知または連絡は、本サイトにログインした際に本サイト上で表示されるメッセージまたはその他当社が別途定める方法によって行うものとします。<br>
      2. 当社は、先生から、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時に先生へ到達したものとみなします。      
    </span>
    <h4>第５条　個人情報の取扱</h4>
    <span>当社は、本サービスの利用によって取得する個人情報については、当社</span>
    <span
      class="caption"
      style="cursor:pointer" 
      @click="$router.push('/policy')">
      <u>「プライバシーポリシー」</u>
    </span> 
    <span>
    に従い適切に取り扱うものとします。<br>
    </span>
    <h3>第２章　会員</h3>
    <h4>第６条　利用登録</h4>
    <span>
      1. 本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了するものとします。<br>
      2. 当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。<br>
      (1)利用登録の申請に際して虚偽の事項を届け出た場合<br>
      (2)本規約に違反したことがある者からの申請である場合<br>
      (3)その他、当社が利用登録を相当でないと判断した場合<br>  
    </span>
    <h4>第７条　権利義務の譲渡禁止</h4>
    <span>先生は、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできないものとします。<br>  
    </span>
    <h4>第８条　アカウントの管理</h4>
    <span>
      1. 先生は、利用に際して登録した情報（以下、「登録情報」といいます。メールアドレスやパスワード等を含みます。）について、自己の責任において適切に管理するものとします。<br>
      2. 先生は、いかなる場合にも、登録情報を第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、先生のメールアドレスとパスワードの組み合わせが一致してログインされた場合には、その利用登録を行った先生自身による利用とみなします。<br>
      3. 先生は、本サービスの利用にあたって当社に申請した事実に変更が生じた場合には、速やかに本サイトを通じて、当該変更の内容について当社に申請するものとします。<br>
      4. 登録情報が第三者によって使用されたことによって生じた損害は、当社に故意または重大な過失がある場合を除き、当社は一切の責任を負わないものとします。<br>
    </span>
    <h3>第３章　サービスの利用</h3>
    <h4>第９条　禁止事項</h4>
    <span>
      (1)当社に虚偽の情報を登録する行為<br>
      (2)本サービスの他の先生またはその他第三者に成りすます行為<br>
      (3)当社または第三者の知的財産権その他財産権、プライバシー権または肖像権を侵害する行為<br>
      (4)当社または第三者の名誉または信用を毀損する行為<br>
      (5)当社または第三者を誹謗中傷する行為<br>
      (6)当社または第三者に不利益、損害、不快感を与える行為<br>
      (7)当社または第三者に対する暴力的、威嚇的、脅迫的な行為<br>
      (8)先生、生徒や他の先生の個人情報等を収集または蓄積する行為<br>
      (9)本サービスによって取得した情報を商業的に利用する行為<br>
      (10)個人情報等を他の先生、その他第三者に漏洩する行為<br>
      (11)当サービスの運営を妨害するおそれのある行為<br>
      (12)当社が許諾しない本サービス上での宣伝、広告、勧誘、または営業行為<br>
      (13)当社、または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為<br>
      (14)法令または公序良俗に違反する行為<br>
      (15)犯罪に結びつく行為<br>
      (16)当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為<br>
      (17)その他、当社が不適切と判断する行為<br>
    </span>
    <h4>第１０条　依頼者等との直接取引の禁止</h4>
    <span>
      1. 先生は、本サービスを通じて知り合った依頼者もしくは生徒またはその知り合いに対し、本サービスを利用せずに家庭教師サービスを提供してはなりません。ただし、当社が本サービスの提供を永続的に終了した後についてはこの限りではありません。<br>
      2. 先生が前項の規定に違反した場合、先生は、本サービスを利用していたならば依頼者が当社に支払ったであろう本サービスの利用料の3倍に相当する金額（その額が100万円に満たない場合は100万円）の違約金を、直ちに当社に支払わなければなりません。<br>
      3. 先生は、当社が前項の違約金の請求にあたって弁護士費用その他費用を要した場合には、その費用についても、直ちに当社に支払わなければなりません。<br>
    </span>
    <h4>第１１条　本サービスの提供の停止等</h4>
    <span>
      1. 当社は、以下のいずれかの事由があると判断した場合、先生に事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。<br>
      (1)本サービスに係るコンピュータシステムの保守点検または更新を行う場合<br>
      (2)地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合<br>
      (3)コンピュータまたは通信回線等が事故により停止した場合<br>
      (4)その他、当社が本サービスの提供が困難と判断した場合<br>
      2. 当社は、本サービスの提供の停止または中断により、先生または第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。<br>      
    </span>
    <h4>第１２条　秘密保持</h4>
    <span>
      先生は、本サービスの利用に関して当社または依頼者もしくは生徒から開示または提供された情報を善良なる管理者の注意をもって取扱い、事前に書面により当社の同意を得ることなく、本サービスの目的以外に使用し、または第三者に開示または提供してはならないものとします。<br>
    </span>
    <h4>第１３条　利用制限等</h4>
    <span>
      1. 当社は、先生が以下のいずれかに該当する場合には、事前の通知なく、先生に対して本サービスの全部もしくは一部の利用を制限し、または先生のアカウントを削除することができるものとします。<br>
      (1)本規約のいずれかの条項に違反した場合<br>
      (2)登録事項に虚偽の事実があることが判明した場合<br>
      (3)先生が暴力団、暴力団関係企業、総会屋もしくはこれらに準ずる者またはその構成員である場合<br>
      (4)当社からの連絡に対し、一定期間返答がない場合<br>
      (5)本サービスについて、最終の利用から一定期間利用がない場合<br>
      (6)その他、当社が本サービスの利用を適当でないと判断した場合<br>
      2. 当社は、本条に基づき当社が行った行為により先生に生じた損害について、一切の責任を負いません。<br>      
    </span>
    <h4>第１４条　家庭教師実施契約</h4>
    <span>
      1. 先生と依頼者が本サイト上で手続を行い、授業サービスを受ける生徒、授業報酬、授業日程その他当社が定める事項について合意した場合には、当該合意に係る事項及び次の各号に基づいて、先生と依頼者との間で家庭教師実施契約が成立するものとします。<br>
      (1)先生は、依頼者と先生との間の合意内容に従って、生徒に授業を行います。<br>
      (2)授業日程の変更、授業のキャンセルその他家庭教師実施契約の内容の変更については、本サイト上で依頼者と先生の双方が手続を終えた時点で有効となります。<br>
      (3)一つの授業が問題なく終了した場合、依頼者は、本サイト上での手続を通して授業報告を行うものとします。当該授業報告に異議がある場合、先生は、依頼者に対して、本サイト上での手続により、当該授業報告の修正依頼を行うものとし、修正依頼が行われなかった場合、当該授業報告に異議がないものとみなします。<br>
      (4)依頼者が授業報告をしなかった場合、授業予定どおりの授業は、キャンセル等によりなされなかったものとみなします。その場合、依頼者は先生に対して授業料を支払う義務を負いません。<br>
      授業報告の内容が授業予定と異なる場合、当該授業報告に対して先生から異議がない限り、授業予定の変更が行われたものとみなし、当該授業報告の内容にて授業が実施されたものとします。<br>
      2. 先生は、家庭教師実施契約は先生と依頼者との間の契約であり、当社は家庭教師実施契約の当事者とならず、当社が家庭教師実施契約に基づく責任を負うものではないことを確認します。<br>     
    </span>
    <h4>第１５条　収納代行</h4>
    <span>
      1. 先生は、本サービスを通じて締結される家庭教師実施契約について依頼者から授業料の収納を行うことを当社に委託し、そのために必要な権限を当社に授与します。ただし、交通費については実費を別途先生と依頼者の間で精算するものとします。<br>
      2. 先生は、前項の規定により、当社に収納を委託した授業料(交通費を除きます。)については、依頼者または生徒から直接収受してはなりません。<br>
    </span>
    <h4>第１６条　利用料</h4>
    <span>
      1. 先生の本サービスの利用料は、家庭教師実施契約に基づく授業について、授業が実施されるたびに、当該授業に係る授業料に当社が定める割合を乗じた金額とします。<br>
      2. 前項の割合は、授業報告等勘案し、当社が定めるものとします。ただし、当該割合は、最大でも○○％とします。

    </span>
    <h4>第１７条　未払報酬残高の加算 </h4>
    <span>
      1. 本利用契約締結時の先生の未払報酬残高は、0円とします。<br>
      2. 先生が家庭教師実施契約に基づき授業を実施した場合、依頼者からの授業報告に基づき、当社は当該授業に係る授業料の金額を先生の未払報酬残高に加算するものとします。<br>      
    </span>
    <h4>第１８条　先生への送金</h4>
    <span>
      1. 当社は、毎月○○日の時点において、前月までに発生した未払報酬残高が残存している場合には、前月までに発生した未払報酬残高の額を、同月○○日までに先生に対してLINEPay送金（以下「送金」といいます。）します。
      当該送金がなされた場合、当該送金額は、先生の未払報酬残高から差し引かれます。<br>
      2. 当社は、当社の責めに帰さない事由により先生に送金ができなかった場合、先生に遅延損害金を支払う義務を負いません。
      この場合、先生は当該送金されるべきだった金額について、当社に対して直ちに、適切かつ合理的な送金依頼を行わなければなりません。当該送金依頼がないまま当初の送金予定日から6か月が経過した場合、当該送金に係る金額は当社に属し、当社は先生への支払義務を免れます。<br>      
    </span>
    <h4>第１９条　サービス内容の変更等</h4>
    <span>
      当社は、先生に通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによって先生に生じた損害について一切の責任を負いません。<br>    
    </span>
    <h3>第４章　その他</h3>
    <h4>第２０条　保証の否認及び免責事項</h4>
    <span>
      1. 当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグまたは不具合、権利侵害などを含みます。）がないことについて、いかなる保証も行うものではありません。<br>
      2. 当社は、本サービスから先生が得る情報（依頼者または生徒の登録情報を含みます。）の正確性等についていかなる保証も行なわず、一切の責任を負いません。先生は、本サービスから得る情報の正確性等につき、自己の責任において判断するものとします。<br>
      3. 当社は、本サービスに関して、先生と依頼者、生徒または第三者との間において生じた取引（家庭教師実施契約を含みます。）、連絡または紛争等について一切責任を負いません。<br>
      4. 当社は、本サービスに起因して先生に生じた損害につき、当社の故意または重過失によらない場合には、免責されるものとします。
      当社が何らかの理由によって責任を負う場合にも、通常生じうる損害の範囲内においてのみ、賠償の責任を負うものとします。<br>
      5. 当社は、本サイトに不具合が生じないことについて、何ら保証するものではありません。
      また、本サイトの先生の利用環境に対する適合性についても保証するものではなく、一切の責任を負いません。<br>
      6. 当社から先生に対して、当社から先生への報酬支払いを目的とした問合わせをしたにも関わらず、先生が6か月以上に渡り適切な返答または情報提供をしなかったことにより支払処理ができなかった場合、当社は当該金員について支払義務を免れるものとします。<br>      
    </span>
    <h4>第２１条　分離可能性</h4>
    <span>
      本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、当該無効または執行不能と判断された規定または部分以外の部分は、継続して完全に効力を有するものとします。<br>
    </span>
    <h4>第２２条　損害賠償</h4>
    <span>
      1. 先生が本サービスの利用に関連して当社に損害を与えた場合、自己の責任と費用をもって損害（訴訟費用及び弁護士費用を含みます。）を賠償するものとします。<br>
      2. 先生の行為により、第三者から当社が損害賠償等の請求をされた場合には、先生の費用と責任で、これを解決するものとします。
      当社が当該第三者に対して損害賠償金その他の費用を支出した場合には、先生は当社に対して、当社に生じた一切の費用（損害賠償金及び弁護士費用を含みます。）を支払うものとします。<br>      
    </span>
    <h4>第２３条　準拠法・裁判管轄</h4>
    <span>
      1. 本規約及びこれらに係る法律行為については、日本法を準拠法とします。<br>
      2. 本サービスに関して紛争が生じた場合には、東京地方裁判所を専属的合意管轄裁判所とします。<br>
    </span>
    <br>
    <span>以上</span><br>
    <span>2019年10月1日制定</span>


  </div>
</template>

<script>
export default {
  name: 'TermsOfTeacherService'
}
</script>

<style scoped>
  .title--text {
    color: black;
    background-color: rgba(188, 232, 243, .70);
    padding: 10px;
    border-radius: 5px;
  }

  .subtitle--text {
    background-color: rgba(188, 232, 243, .25);
    padding:5px 10px;
    margin: 30px 0px 0px 0px;
    border-radius: 5px;
  }

  .plain--text {
    letter-spacing: 0px;
    font-size: 0.92rem;
    margin: 10px 20px 10px 10px;
  }

  .plain--list {
    letter-spacing: 0px;
    font-size: 0.92rem;
    margin: 10px 20px 10px 10px;
  }

  .plain--list li {
    margin: 0px 0px 3px 0px
  }

  .plain--text.end {
    text-align: right;
    padding: 10px
  }
</style>